import { buildUnifiedAccount } from 'unified-auth-core-lib';
import { DEFAULT_PROVIDER_KEY, PROVIDER_KEYS } from './registry';
import { getAppIdByAppName, getGoogleSheetsAppId, getMicrosoftDriveAppId, getSlackIntegrationAppId, getZoomInfoAppId, INTEGRATIONS_DASHWORKS } from '../constants/appIds';
const getDashworksAppIds = () => Object.values(INTEGRATIONS_DASHWORKS).map(getAppIdByAppName).filter(id => id !== undefined);
export function initializeDefaults(registry) {
  const DefaultComponents = buildUnifiedAccount({
    displayName: 'UnifiedAccount'
  });
  registry.registerProvider(DEFAULT_PROVIDER_KEY, {
    components: DefaultComponents
  });
  registry.registerProvider(PROVIDER_KEYS.UNIFIED_ACCOUNT, {
    components: DefaultComponents,
    overwrite: true
  });
  registry.registerProvider(PROVIDER_KEYS.DASHWORKS, {
    appIds: getDashworksAppIds(),
    load: () => import( /* webpackChunkName: "unified-auth-dashworks" */'ui-universal-auth/providers/dashworks').then(m => m.DashworksAuth)
  });
  registry.registerProvider(PROVIDER_KEYS.ZOOMINFO, {
    appIds: [getZoomInfoAppId()],
    load: () => import( /* webpackChunkName: "unified-auth-zoominfo" */'ui-universal-auth/providers/zoominfo').then(m => m.ZoomInfoAuth)
  });
  registry.registerProvider(PROVIDER_KEYS.MICROSOFT_DRIVE, {
    appIds: [getMicrosoftDriveAppId()],
    load: () => import( /* webpackChunkName: "unified-auth-microsoft-drive" */'microsoft-drive-integration-lib/auth').then(m => m.MicrosoftDriveAuth)
  });
  registry.registerProvider(PROVIDER_KEYS.GOOGLE_SHEETS, {
    appIds: [getGoogleSheetsAppId()],
    load: () => import( /* webpackChunkName: "unified-auth-google-sheets" */'google-sheets-integration-lib/auth').then(m => m.GoogleSheetsAuth)
  });
  registry.registerProvider(PROVIDER_KEYS.SLACK_INTEGRATION, {
    appIds: [getSlackIntegrationAppId()],
    load: () => import( /* webpackChunkName: "unified-auth-slack-integration" */'slack-ui-library/auth').then(m => m.SlackAuth)
  });
}